export default {
  styleOverrides: {
    root: {
      padding: 24
    }
  }
}
